import {
	Box,
	Table,
	TableContainer,
	TableProps,
	Tbody,
	Td,
	Th,
	Thead,
	Tr,
	chakra,
} from '@chakra-ui/react';
import DescreaseSortIcon from '../../Icons/DescreaseSortIcon';
import IncreaseSortIcon from '../../Icons/IncreaseSortIcon';
import styled from '@emotion/styled';
import TextGradient from '../../UI/TextGradient';

interface FundTableDesktopProps extends TableProps {
	list: any;
}
const Actions = styled(Box)`
	display: flex;
	align-items: center;
	gap: 16px;
	width: 100%;
	justify-content: flex-end;
`;
const StyledTextGradient = styled(TextGradient)`
	cursor: pointer;
	&:hover {
		filter: brightness(1.2);
	}
`;
const TokenWrapper = styled(Box)`
	display: flex;
	align-items: center;
	gap: 8px;
`;
const TokenImage = styled.img`
	width: 35px;
	height: 35px;
	object-fit: contain;
	border-radius: 100%;
`;
const TokenName = styled(Box)`
	color: #737283;
	font-size: 14px;
	line-height: 16px;
`;
const TokenSymbol = styled(Box)`
	color: #ffffff;
	font-size: 16px;
	line-height: 1;
`;

const TokenInfo = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 5px;
`;

const SortIconWrapper = styled(Box)`
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 2px;
`;
const TitleWrapper = styled(Box)`
	display: flex;
	align-items: center;
	gap: 4px;
`;

const HeadCell = chakra(Th, {
	baseStyle: {
		borderBottom: '1px solid #FFFFFF1E',
		textTransform: 'capitalize',
		fontFamily: 'Roboto',
		color: '#737283',
		fontWeight: 400,
		fontSize: '14px',
		padding: '25px 0',
	},
});

const BodyCell = chakra(Td, {
	baseStyle: {
		borderBottom: '1px solid #FFFFFF1E',
		padding: '25px 0',
	},
});

const FundTableDesktop = ({ list, ...props }: FundTableDesktopProps) => {
	return (
		<TableContainer style={{ width: '100%' }}>
			<Table {...props}>
				<Thead>
					<Tr>
						<HeadCell>Token</HeadCell>
						<HeadCell>
							<TitleWrapper>
								Total{' '}
								<SortIconWrapper>
									<IncreaseSortIcon />
									<DescreaseSortIcon />
								</SortIconWrapper>
							</TitleWrapper>
						</HeadCell>
						<HeadCell>
							<TitleWrapper>
								Available{' '}
								<SortIconWrapper>
									<IncreaseSortIcon />
									<DescreaseSortIcon />
								</SortIconWrapper>
							</TitleWrapper>
						</HeadCell>
						<HeadCell>In Order</HeadCell>
						<HeadCell>Valuation(USD)</HeadCell>
						<HeadCell isNumeric>Action</HeadCell>
					</Tr>
				</Thead>
				<Tbody>
					{list.map((item: any, index: any) => (
						<Tr key={index}>
							<BodyCell>
								<TokenWrapper>
									<TokenImage
										src={item.currency.icon}
										alt={item.currency.name}
									/>
									<TokenInfo>
										<TokenSymbol>{item.currency.symbol}</TokenSymbol>
										<TokenName>{item.currency.name}</TokenName>
									</TokenInfo>
								</TokenWrapper>
							</BodyCell>
							<BodyCell>{item.total}</BodyCell>
							<BodyCell>{item.available}</BodyCell>
							<BodyCell>{item.inOrder}</BodyCell>
							<BodyCell>${item.valuation}</BodyCell>
							<BodyCell isNumeric>
								<Actions>
									<StyledTextGradient>Deposit</StyledTextGradient>
									<StyledTextGradient>Withdraw</StyledTextGradient>
									<StyledTextGradient>Trade</StyledTextGradient>
								</Actions>
							</BodyCell>
						</Tr>
					))}
				</Tbody>
			</Table>
		</TableContainer>
	);
};

export default FundTableDesktop;
